module.exports = __webpack_public_path__ + "img/couples-072.5fa22fc5.jpg";